import { useMemo } from 'react';

import { Coordinates } from '@ocx-app/modules/stores/types';
import { useGeolocation } from '@ocx-app/lib/geolocation/useGeolocation';

import { useConfiguration } from '@ocx/data-configuration';

type UseCurrentLocation = {
  // user physical location
  currentLocation: Coordinates;
  isLocationEstablished: boolean;
  isLocationPermissionDenied: boolean;
  isLocationPending: boolean;
};

export const useCurrentLocation = (): UseCurrentLocation => {
  const { status, coordinates, loading } = useGeolocation({ watch: true });
  const defaultLocation = useConfiguration('storeLocator.defaultLocation');

  const isLocationPermissionDenied = status === 'denied';

  return useMemo(
    () => ({
      currentLocation: !isLocationPermissionDenied && coordinates !== null ? coordinates : defaultLocation,
      isLocationEstablished: !isLocationPermissionDenied && coordinates !== null,
      isLocationPermissionDenied,
      isLocationPending: loading,
    }),
    [coordinates, defaultLocation, isLocationPermissionDenied, loading],
  );
};
